import React from "react";
import moment from "moment";
import Chart from "react-apexcharts";

const DailyRegistered = ({ registered }) => (
    <Chart
        options={{
            chart: {
                id: "daily-range-registered-bar",
                toolbar: {
                    show: true
                },
                zoom: {
                    enabled: true,
                    type: "x",
                    autoScaleYaxis: false,
                    zoomedArea: {
                        fill: {
                            color: "#90CAF9",
                            opacity: 0.4
                        },
                        stroke: {
                            color: "#0D47A1",
                            opacity: 0.4,
                            width: 1
                        }
                    }
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: "55%",
                    endingShape: "rounded"
                },
            },
            stroke: {
                curve: "smooth"
            },
            xaxis: {
                categories: Object
                    .keys(registered)
                    .map(timestamp => moment(parseInt(timestamp, 10))
                        .format("YYYY-MM-DD")),
                type: "datetime",
                labels: {
                    format: "dd MMM (ddd)"
                }
            },
            markers: {
                size: 6,
                strokeWidth: 3,
                fillOpacity: 0,
                strokeOpacity: 0,
                hover: {
                    size: 8
                }
            },
            dataLabels: {
                enabled: false
            },
        }}
        series={[{
            name: "Registered Users",
            data: Object.keys(registered)
                .map(day => registered[day].registeredUsersCount)
        }, {
            name: "Card Attachment",
            data: Object.keys(registered)
                .map(day => registered[day].cardAttachmentsCount)
        }]}
        type="bar"
        width="100%"
        height={300}
    />
);

export default DailyRegistered;



// WEBPACK FOOTER //
// ./src/views/pages/reports/daily-registered.js